import React from 'react';
import JMSLogo from "@Assets/domain/logo/jms-logo.png";

function LogoLogin(props: { branding: string}) {
  const { branding } = props;
  const isRepsol = branding === "REPSOL";
  const isAlinta = branding === "ALINTA";
  const repsolLogoSize = (isRepsol ? 250 : isAlinta ? 'auto' : 130);
  return (
    <div className="text-center my-6">
      <img
        src={import.meta.env.VITE_LOGIN_SCREEN_LOGO ? new URL(import.meta.env.VITE_LOGIN_SCREEN_LOGO, import.meta.url).href: JMSLogo}
        alt="JMS"
        height={branding === 'JMS' ? 66 : repsolLogoSize}
        style={{
          maxWidth: isAlinta || isRepsol ? '70%'  : '35%',
          objectFit: 'contain',
          width: 'auto'
        }}
      />
    </div>
  );
}

export default LogoLogin;
